import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>EdenPlaisir.com</h3>
            <p>Votre plateforme de contenu premium</p>
          </div>
          
          <div className="footer-section">
            <h4>Informations légales</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy-policy">Politique de confidentialité</Link>
              </li>
              <li>
                <Link to="/legal-notice">Mentions légales</Link>
              </li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Sites partenaires</h4>
            <ul className="footer-links">
              <li>
                <a href="https://pure-porn.com" target="_blank" rel="noopener noreferrer">
                  Pure Porn
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} EdenPlaisir.com - Tous droits réservés</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer

